<template>
    <div v-if="textOnly" :class="['download-file-xlsx__text-wrap', divClass]">
        <button type="button" class="download-file-xlsx__text" :style="textStyle" :disabled="disabled" @click="download">
            {{ text }}
        </button>
    </div>
    <div v-else :class="['download-file-xlsx', divClass]">
        <v-btn
            v-bind="$attrs"
            class="download-file-xlsx__button"
            :loading="loader && loading"
            :disabled="disabled || (loader && loading)"
            @click="download"
        >
            <span class="download-file-xlsx__label">{{ text }}</span>
            <span class="download-file-xlsx__hint">XLSX</span>
        </v-btn>
    </div>
</template>

<script>
import XLSX from 'xlsx'

export default {
    name: `DownloadFileXlsx`,
    props: {
        icon: {
            type: Boolean,
            default: false
        },

        divClass: {
            type: String,
            default: `text-xs-center`
        },
        loader: {
            type: Boolean,
            default: false
        },
        textOnly: {
            type: Boolean,
            default: false
        },
        tableArray: {
            type: Array,
            required: true
        },
        tableHeader: {
            type: Array,
            required: true
        },
        fileName: {
            type: String,
            default: `download.xlsx`
        },
        text: {
            type: String,
            default: `Download File`
        },
        textStyle: {
            type: String,
            default: ``
        },
        dataFunc: {
            type: Function,
            default: undefined
        },
        disabled: {
            type: Boolean,
            required: false
        }
    },
    data() {
        return {
            loading: false,
            apiResponse: {
                data: null
            }
        }
    },
    methods: {
        getValue(obj, path) {
            // in case the value is nested
            return path.split('.').reduce((acc, key) => acc?.[key], obj)
        },
        async download() {
            if (this.loading || this.disabled) return
            try {
                this.loading = true
                if (this.dataFunc) await this.dataFunc()
                let xlsxData = [this.tableHeader.map((header) => header.text)]
                if (this.tableArray.length > 0) {
                    // convert data into a new array
                    xlsxData = xlsxData.concat(
                        this.tableArray.map((lineItem) => {
                            return this.tableHeader.map((header) => {
                                let itemVal = this.getValue(lineItem, header.value)

                                 // format date 
                                if (itemVal && ['createdAt', 'closedAt'].includes(header.value)) {
                                    const date = new Date(itemVal)
                                    itemVal = date.toLocaleDateString()                                   
                                }

                                // check advance exchange
                                if (itemVal && header.value === "rmaType") {
                                    const advanceEx = itemVal === 'GVS_ADVANCE_EXCHANGE' ? 'Yes' : 'No'
                                    itemVal = advanceEx
                                }
                                return itemVal
                            })
                        })
                    )
                    const wb = XLSX.utils.book_new()
                    const ws = XLSX.utils.aoa_to_sheet(xlsxData)
                    XLSX.utils.book_append_sheet(wb, ws, 'report')
                    XLSX.writeFile(wb, this.fileName)
                }

                this.loading = false
                this.$emit(`onSuccess`, 200)
            } catch (error) {
                alert(`Error Downloading File`)
                this.loading = false
                this.$emit(`onError`, 400)
            }
        }
    }
}
</script>

<style scoped>
.download-file-xlsx {
    display: inline-flex;
    max-width: 100%;
}
.download-file-xlsx__button.v-btn {
    min-height: 38px;
    padding: 0 10px 0 14px;
    color: #fff !important;
    background: #db5120 !important;
    border: 1px solid rgba(255, 185, 154, 0.28);
    border-radius: 7px;
    box-shadow: 0 5px 14px rgba(219, 81, 32, 0.16);
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.1px;
    text-transform: none;
    transition: background-color 140ms ease, border-color 140ms ease, transform 140ms ease;
}
.download-file-xlsx__button.v-btn::before {
    opacity: 0 !important;
}
.download-file-xlsx__button.v-btn:hover {
    transform: translateY(-1px);
    background: #e76638 !important;
    border-color: rgba(255, 185, 154, 0.52);
    box-shadow: 0 7px 18px rgba(219, 81, 32, 0.25);
}
.download-file-xlsx__button.v-btn:focus-visible,
.download-file-xlsx__text:focus-visible {
    outline: 2px solid #f0784c;
    outline-offset: 3px;
}
.download-file-xlsx__label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.download-file-xlsx__hint {
    margin-left: 9px;
    padding: 4px 6px;
    color: #ffe1d3;
    background: rgba(24, 22, 22, 0.18);
    border: 1px solid rgba(255, 255, 255, 0.19);
    border-radius: 4px;
    font-size: 8px;
    font-weight: 700;
    letter-spacing: 0.4px;
    line-height: 1;
}
.download-file-xlsx__text-wrap {
    display: inline-flex;
}
.download-file-xlsx__text {
    padding: 0;
    color: #ff9a74;
    background: transparent;
    border: 0;
    font: inherit;
    cursor: pointer;
}
.download-file-xlsx__text:hover {
    text-decoration: underline;
}
.download-file-xlsx__text:disabled {
    opacity: 0.55;
    cursor: not-allowed;
}
@media (prefers-reduced-motion: reduce) {
    .download-file-xlsx__button.v-btn {
        transition: none;
    }
}
</style>